// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"352":"onboarding","962":"home"}[chunkId] + "." + {"352":"6d141d0d","962":"c9d1d8e9"}[chunkId] + ".chunk.css";
};